// extracted by mini-css-extract-plugin
module.exports = {"ratingsContainer":"Ratings_ratingsContainer__kxDOh","diceRatings":"Ratings_diceRatings___Jv3Z"};